import { Button } from "@/components/ui/button";
import { Sparkles, Download, Zap } from "lucide-react";
import heroImage from "@/assets/hero-photo-to-sketch.jpg";
import { useAnimatedCounter } from "@/hooks/useAnimatedCounter";
import { useEffect, useState } from "react";

const Hero = () => {
  const [startCounter, setStartCounter] = useState(false);
  const counterValue = useAnimatedCounter(5000, 2000, startCounter);

  useEffect(() => {
    const timer = setTimeout(() => setStartCounter(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="py-20 px-4 bg-gradient-subtle/80 relative">
      <div className="container mx-auto text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent rounded-full mb-6 animate-fade-in min-h-[36px]" style={{ contain: 'layout' }}>
            <Sparkles className="w-4 h-4 text-accent-foreground animate-pulse" />
            <span className="text-sm font-medium text-accent-foreground">
              Over {counterValue.toLocaleString()} coloring pages created!
            </span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-hero bg-clip-text text-transparent leading-tight" style={{ contain: 'layout' }}>
            Transform your precious memories into creative coloring pages and personalized e-cards
          </h1>
          
          <p className="hidden md:block text-xl text-muted-foreground mb-8 max-w-2xl mx-auto" style={{ contain: 'layout' }}>
            SKECHA turns your family photos into personalized coloring pages that bring those special moments to life. 
            Upload any image and watch as we create beautiful, printable coloring experiences that spark imagination and family connection.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              variant="hero" 
              size="xl" 
              className="group"
              data-gtm-event="cta_click"
              data-gtm-cta_label="Start for free"
              data-gtm-page_section="hero"
              onClick={() => document.getElementById('generator')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <Zap className="w-5 h-5 group-hover:animate-pulse" />
              Start for free
            </Button>
            <Button 
              variant="outline" 
              size="xl"
              data-gtm-event="cta_click"
              data-gtm-cta_label="View Gallery"
              data-gtm-page_section="hero"
              onClick={() => document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <Download className="w-5 h-5" />
              View Gallery
            </Button>
          </div>
          
          <div className="text-sm text-muted-foreground mb-8">
            No credit card. Just creativity.
          </div>
          
          <div className="relative max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-creative hand-drawn">
            <img 
              src={heroImage} 
              alt="AI Generated Coloring Pages" 
              className="w-full h-auto"
              width={1920}
              height={1080}
              loading="eager"
              fetchPriority="high"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;